(() => {
    const clipboardButton = document.querySelector("button.clipboard");

    if (!clipboardButton) {
        return;
    }

    clipboardButton.addEventListener("click", async (event) => {
        event.preventDefault();

        const pageUrl = window.location.href;
        const shouldCopy = confirm("Copy this page URL to your clipboard?");

        if (!shouldCopy) {
            return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(pageUrl);
                return;
            } catch (error) {
                return;
            }
        }
    });
})();
